import ResetZoomButton from '@components/ResetZoomButton'
import { useStoreMapContext } from '@components/storeMap/provider/StoreMapContext'
import { useIsWideLayout } from '@hooks/useMediaQuery'

function StoreMapResetZoomButton() {
  const { resetZoom, isTransformed } = useStoreMapContext()
  const isWideLayout = useIsWideLayout()

  return (
    <ResetZoomButton
      resetZoom={resetZoom}
      showButton={isTransformed && isWideLayout}
    />
  )
}

export default StoreMapResetZoomButton